module.exports = __webpack_public_path__ + "imgs/wheresadweed.a9186ab4786e0e8934cab1d215d8c588.svg";